import React from 'react';
const ProductTileSkeleton = () => {
    return (React.createElement(React.Fragment, null, Array.from({ length: 12 }, (item, index) => (React.createElement("div", { key: index, className: "collection__placeholder collection__placeholder--loading" },
        React.createElement("div", { className: "collection__placeholder--image" }),
        React.createElement("div", { className: "collection__placeholder--title" }),
        React.createElement("div", { className: "collection__placeholder--price" }),
        React.createElement("div", { className: "collection__placeholder--button" }))))));
};
export default ProductTileSkeleton;
